export const breakpoints = {
  xs: 0,
  sm: 360,
  md: 600,
  lg: 960,
  xl: 1280,
};
